import React,{useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "./Loading";

function Home()
{
    const {setLoading} = useLoading();
    useEffect(()=>{
              setTimeout(() => {
                  setLoading(false);
              }, 50);
          },[]);
    
    const navigate = useNavigate();

    document.addEventListener('scroll', () => {
        const heroSection = document.querySelector('.imageContainer');
        const backgroundImage = document.querySelector('.homeImage');
        const zoomElements = document.querySelectorAll('.imageHeader');
        const zoomTexts = document.querySelectorAll('.imageText');

    const adoptionSection = document.getElementById('processStepContainer');
    const adoptionSteps = document.querySelectorAll('.processImg');
  
    if (adoptionSection) {
        const sectionTop = adoptionSection.offsetTop;
        const windowHeight = window.innerHeight;
        const scrollPosition = window.scrollY;
    
        adoptionSteps.forEach(step => {
          const stepTop = step.offsetTop;
          const stepHeight = step.offsetHeight;
    
          // Calculate when the step starts to become visible in the viewport (from the bottom)
          const triggerPoint = stepTop - windowHeight + stepHeight * 0.5; // Adjust 0.5 for when the middle of the element enters
    
          if (scrollPosition >= triggerPoint) {
            // Fade in and move up to original position
            const distanceScrolledIntoView = scrollPosition - triggerPoint;
            const normalizedProgress = Math.min(1, distanceScrolledIntoView / (windowHeight * 0.5)); // Animate over half the viewport height
    
            step.style.opacity = normalizedProgress;
            step.style.transform = `translateY(${50 - (normalizedProgress * 50)}px)`; // Move from 50px up to 0px
          } else {
            // Reset to initial state if the trigger point hasn't been reached
            step.style.opacity = 0;
            step.style.transform = `translateY(50px)`;
          }
        });
      }
  
      
        if (heroSection && backgroundImage) {
          const scrollPosition = window.scrollY;
          const heroHeight = heroSection.offsetHeight;
      
          zoomElements.forEach(element => {
            // Calculate the scale factor to zoom out on scroll
            const scaleFactor = Math.max(0.7, 1 - (scrollPosition / heroHeight) * 0.3);
      
            element.style.transform = `scale(${scaleFactor})`;
          });
          zoomTexts.forEach(element => {
            // Calculate the scale factor to zoom out on scroll
            const scaleFactor = Math.max(0.7, 1 - (scrollPosition / heroHeight) * 0.3);
      
            element.style.transform = `scale(${scaleFactor})`;
          });

          const opacityValue = Math.max(0, 1 - (scrollPosition / heroHeight)); // Starts at 1, decreases with scroll
      
          backgroundImage.style.opacity = opacityValue;
        }
      });
    return(
        <section>

            <div className="homeContainer">
            <div className="imageContainer">
                <div className="textContainer">
                    <div className="homeText">
                        <h1 className="imageHeader">Pet Adoption Platform</h1>
                        <p className="imageText">
                        With our motto, we encourage people to adopt pets instead of 
                        purchasing. Our main aim is to find a lifelong family in loving homes 
                        for all the strays and unwanted pets.
                        </p>
                    </div>
                </div>

                    <img src="/homePicture.jpg" alt="Home Background" className="homeImage" />
            </div>
                <div className="processStepContainer" id="processStepContainer">
                    <h1 className="stepText">Adoption Process Step</h1>
                    <div className="aboutUsProcessContainer">

                        <div className="processImg"><img src="/apply.png" alt="apply adoption" /><span>Apply and Schedule Visit <br></br>within 2 weeks</span></div>
                        <div className="processImg"><img src="/meet.png" alt="meet with shelter" /><span>Meet Shelter and wait for<br></br> Final Decision</span></div>
                        <div className="processImg"><img src="/take.png" alt="take pet home" /><span>Take Pet Home</span></div>
                    </div>
                </div>
                <div className="homeBody" id="homeBody">
                    <h1>Find Your Partner</h1>

                    <div className="btnCategory" >
                        <button className="btnCategory1" onClick={() => navigate('/adopt', { state: { petType: "Dog" } })}> <img src="/dogButton.png" alt="Dogs Category" /><span className="btnText">Dogs</span></button>
                        <button className="btnCategory1" onClick={() => navigate('/adopt', { state: { petType: "Cat" } })}><img src="/catButton.png" alt="Cats Category" /><span className="btnText">Cats</span></button>
                        <button className="btnCategory1" onClick={() => navigate('/adopt', { state: { petType: "Other" } })}><img src="/otherButton.png" alt="Other Category" /><span className="btnText">Others</span></button>
                    </div>

                </div>
            </div>


        </section>
    );

}

export default Home;
